import PropTypes from "prop-types";
import classNames from "classnames";

const IconBack = ({ className, height = "24px", width = "24px" }) => {
    const classes = classNames("backIcon", className);
    return (
        <svg
            className={classes}
            width={width}
            height={height}
            viewBox="0 0 24 24"
            focusable="false"
            aria-hidden="true"
        >
            <path d="M0 0h24v24H0z" fill="none" />
            <path d="M20 11H7.83l5.59-5.59L12 4l-8 8 8 8 1.41-1.41L7.83 13H20v-2z" />
        </svg>
    );
};

IconBack.propTypes = {
    className: PropTypes.string,
    height: PropTypes.string,
    width: PropTypes.string,
};

export default IconBack;
